import type { Logger, LoggerConfig, LoggerOptions } from '@/types/Logger';

export abstract class LoggerService {
  abstract createLogger(options: LoggerOptions): Logger;
  abstract configure(config: LoggerConfig): void;
  abstract enable(pattern: string): void;
  abstract disable(pattern: string): void;
  abstract disableAll(): void;
  abstract refreshFromStorage(): void;
}
